import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import De from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as X } from "../util/date-utils.js";
import {
  logger as E,
  Guid as P,
  EventTypes as f,
} from "../../shared-lib/index.js";
export default class Vt {
  constructor(s, t, i, e) {
    (this.B = s),
      (this.vs = t),
      (this.h = i),
      (this.tm = e),
      (this.B = s),
      (this.vs = t),
      (this.h = i),
      (this.im = 1e3),
      (null == e || isNaN(e)) && (e = 1800),
      e < this.im / 1e3 &&
        (E.info(
          "Specified session timeout of " +
            e +
            "s is too small, using the minimum session timeout of " +
            this.im / 1e3 +
            "s instead.",
        ),
        (e = this.im / 1e3)),
      (this.tm = e);
  }
  nm(s, t) {
    return new De(this.vs.getUserId(), f.hm, s, t.Tu, { d: X(s - t.lm) });
  }
  yt() {
    const t = this.B.$u(s.Ou.um);
    return null == t ? null : t.Tu;
  }
  am() {
    const t = new Date().valueOf(),
      i = this.h._c();
    if (null == i) return !1;
    const e = this.B.dt(s.ft.dm),
      n = null == e || t - e > 1e3 * i;
    return n && this.B.bt(s.ft.dm, t), n;
  }
  fm(s, t) {
    return null == t || null == t.pm || (!(s - t.lm < this.im) && t.pm < s);
  }
  el() {
    const t = new Date().valueOf(),
      i = t + 1e3 * this.tm,
      e = this.B.$u(s.Ou.um);
    if (this.fm(t, e)) {
      let n = "Generating session start event with time " + t;
      if (null != e) {
        let s = e.gm;
        s - e.lm < this.im && (s = e.lm + this.im),
          this.B.wm(this.nm(s, e)),
          (n += " (old session ended " + s + ")");
      }
      (n += ". Will expire " + i.valueOf()), E.info(n);
      const o = new _t(P.se(), i);
      this.B.wm(new De(this.vs.getUserId(), f.Sm, t, o.Tu)),
        this.B.Iu(s.Ou.um, o);
      return null == this.B.dt(s.ft.dm) && this.B.bt(s.ft.dm, t), o.Tu;
    }
    if (null != e) return (e.gm = t), (e.pm = i), this.B.Iu(s.Ou.um, e), e.Tu;
  }
  jm() {
    const t = this.B.$u(s.Ou.um);
    null != t &&
      (this.B.xm(s.Ou.um), this.B.wm(this.nm(new Date().valueOf(), t)));
  }
}
